import axios from 'axios'
import { Message, Notification } from 'element-ui'
import store from '@/store'
import router from '@/router'
import { getToken } from '@/utils/auth'

axios.defaults.withCredentials = true
axios.defaults.crossDomain = true

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 1800000, // request timeout
})
service.all = axios.all

const expireSession = () => {
  store.dispatch('user/resetToken').then(() => {
    Message({
      type: 'warning',
      message: '检测到该用户未登录或登录已失效',
      showClose: true
    })
    router.push({ path: '/login' })
  })
}
// request interceptor
service.interceptors.request.use(
  (config) => {
    let url = config.url
    // do something before request is sent
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      if (config.headers.auth) {
        config.headers['Authorization'] = 'Bearer ' + getAuthToken()
      } else {
        config.headers['satoken'] = getToken()
      }
      config.headers['t'] = Date.parse(new Date())
    }
    if (config.method === 'get') {
      url.indexOf('?') === -1
        ? (config.url = url + '?_=' + new Date().getTime())
        : (config.url = url + '&_=' + new Date().getTime())
    }
    config.headers['x-requested-with'] = 'XMLHttpRequest'
    return config
  },
  (error) => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const res = response.data
    if (
      response.headers['content-type'] == 'application/vnd.ms-excel' ||
      response.headers['content-type'] ==
        'application/vnd.ms-excel;charset=utf-8' ||
      response.headers['content-type'] == 'application/octet-stream' ||
      response.headers['content-type'] ==
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' ||
      response.headers['content-type'] ==
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ) {
      return res
    }
      
    if (response.status !== 200) {
      try {
        if (res.code === 403) {
          Message({
            type: 'warning',
            message: '您无此权限，将跳回上一页',
            showClose: true
          })
          router.go(-1)
        } else if (res.msg.includes('not bound')) {
          return res
        } else if (res.code === 500) {
          Message({
            type: 'warning',
            message: res.message || res.msg,
            showClose: true
          })
        } else if (res.msg.includes('未登录') || res.code == 401) {
          expireSession();
        } else {
          Message({
            message: res.message || res.msg || 'Error',
            type: 'error',
            duration: 2 * 1500,
            showClose: true
          })
        }
      } catch (error) {
        console.error(error.message)
      }

      return Promise.reject(new Error(res.message || res.msg || 'Error'))
    } else {
      if (res.code != 200) {
        Message({
          type: 'warning',
          message: res.message || res.msg,
          showClose: true
        })
      }
      return res
    }
  },
  (error) => {
    const errStatus = error.response.data.code
    switch (errStatus) {
      case 417:
        break
      case 401:
        expireSession();
        break
      case 500:
        Notification({
          message: error.response.data.data,
          type: 'warning',
          duration: 2 * 1500,
          showClose: true
        })
        break;
      default:
        Notification({
          message: error.message,
          type: 'error',
          duration: 2 * 1500,
          showClose: true
        })
        break
    }
    return Promise.reject(error)
  }
)

export default service
